"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const currencydollar = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-currencydollar` : '') + (description ? ` desc-currencydollar` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-currencydollar"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-currencydollar"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0.9375C12.3797 0.9375 12.6935 1.21965 12.7432 1.58573L12.75 1.6875V3.6875H16.125C16.5392 3.6875 16.875 4.02329 16.875 4.4375C16.875 4.8172 16.5928 5.13099 16.2268 5.18065L16.125 5.1875H10.9C9.64355 5.1875 8.625 6.20605 8.625 7.4625C8.625 8.71324 9.23941 9.48491 11.0945 10.615L11.5639 10.8936L12.0828 11.1885L12.6588 11.5076L13.2184 11.826L13.7325 12.1316C16.0271 13.5323 16.875 14.6026 16.875 16.5375C16.875 18.5572 15.2889 20.2065 13.2943 20.3076L13.1 20.3125H12.75V22.3125C12.75 22.7267 12.4142 23.0625 12 23.0625C11.6203 23.0625 11.3065 22.7803 11.2568 22.4143L11.25 22.3125V20.3125H7.875C7.46079 20.3125 7.125 19.9767 7.125 19.5625C7.125 19.1828 7.40715 18.869 7.77323 18.8193L7.875 18.8125H13.1C14.3564 18.8125 15.375 17.7939 15.375 16.5375C15.375 15.2868 14.7606 14.5151 12.9055 13.385L12.4361 13.1064L11.9172 12.8115L11.3412 12.4924L10.7816 12.174L10.2675 11.8684C7.97289 10.4677 7.125 9.39735 7.125 7.4625C7.125 5.44278 8.71114 3.79352 10.7057 3.69241L10.9 3.6875H11.25V1.6875C11.25 1.27329 11.5858 0.9375 12 0.9375Z",
    fill: "inherit"
  }));
};
var _default = exports.default = currencydollar;